
import Accordion from '@/ui-kit/components/accordion';
import { AccordionSlotName } from '@/ui-kit/components/accordion/enums';
import { TypographyType } from '@/ui-kit/components/typography/enums';
import Typography from '@/ui-kit/components/typography';
import StyleClassNamesBuilder from '@/ui-kit/styles/helpers/StyleClassNamesBuilder';
import ContainerOverviewNavigationList from './list';

export default {
  name: 'ContainerOverviewNavigation',
  components: {
    Accordion,
    Typography,
    ContainerOverviewNavigationList,
  },
  props: {
    isMobile: {
      default: false,
      type: Boolean,
    },
    isSticky: {
      default: true,
      type: Boolean,
    },
  },
  data() {
    return {
      AccordionSlotName,
      TypographyType,
    };
  },
  computed: {
    containerOverviewNavigationClassNames() {
      return new StyleClassNamesBuilder('container-overview-navigation')
        .addConditionClassName('sticky', this.isSticky)
        .build();
    },
  },
};
